import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

import { Modals } from '../../constants/ScreenNames';

import ExpenseFormItem from './ExpenseFormItem';
import { Color, CommonStyles } from '../../styles';

const ExpenseCategorySelector = ({
  isEditable,
  currentSelectedSubCategory,
  actionType,
  subTab,
}) => {
  const navigation = useNavigation();
  const { t } = useTranslation(i18nNS.tripExpense);
  const { tKey } = useComponentTKey('ExpenseWidget');

  return (
    <TouchableOpacity
      onPress={() =>
        navigation.navigate(Modals.CategorySelectorModal, {
          subCategory: currentSelectedSubCategory,
          actionType,
          subTab,
        })
      }
      style={!isEditable ? CommonStyles.disabledFormInput : null}
      disabled={!isEditable}
    >
      <ExpenseFormItem
        label={t(tKey('Category'))}
        value={currentSelectedSubCategory ? currentSelectedSubCategory.Name : null}
        // icon="list"
        isCaretDownIcon={isEditable}
        style={styles.bottomBorder}
      />
    </TouchableOpacity>
  );
};

export const styles = StyleSheet.create({
  bottomBorder: {
    borderBottomWidth: 0.4,
    borderColor: Color.formDividerColor,
  },
});

export default ExpenseCategorySelector;
